import { Injectable, inject } from "@angular/core";
import { CLIPBOARD } from "../tokens";
import { ToastService } from "src/app/services/toast.service";

@Injectable({
  providedIn: "root",
})
export class CopyValueToClipboardService {
  private readonly clipboard = inject<Clipboard>(CLIPBOARD);
  private readonly toastService = inject(ToastService);

  public copy(value: string, feedbackMessage?: string): void {
    this.clipboard.writeText(value).then(() => {
      if (feedbackMessage) {
        this.toastService.show({ text: feedbackMessage });
      }
    });
  }
}
